import IApplicationState from 'app/types/state';

export function getCurrentPayout(state: IApplicationState) {
  if (
    state.payouts.payoutsById !== undefined
    && state.payouts.currentPayoutId !== undefined
  ) {
    return state.payouts.payoutsById[state.payouts.currentPayoutId];
  }
  return {};
}

export function getCurrentFormPayout(state: IApplicationState) {
  return {
    ...getCurrentPayout(state),
    ...state.payouts.requestedData,
  };
}

export function getPayouts(state: IApplicationState) {
  return {
    ...state.payouts,
    currentPayout: getCurrentPayout(state),
    currentFormPayout: getCurrentFormPayout(state),
  };
}

export function getPayoutSummary(payout, dragSelected = false, rows = {}): any {
  const payoutSummary = {
    id: payout.id,
    mobile: payout.mobile,
    email: payout.email,
    fullName: payout.fullName,
    teams: { name: payout.teamName },
    dragSelected,
    selected: rows[payout?.id]?.selected,
    financialStatus: {
      owingNumber: payout.pendingPaymentCollectionsTotalCount,
      overdueNumber: payout.overduePaymentCollectionsTotalCount,
    },
    amount: rows[payout?.id]?.amount,
  };
  return payoutSummary;
}
